// @flow

import { createAction }     from 'redux-actions';
import type { ResourceIRI } from '../../../domain/types';


type JWT = {
  '@context': '/contexts/JWT',
  token: string,
  refreshToken: string,
  userId: ResourceIRI,
};


// -----------------------------------------------------------------------------------------------------------------
// 'AUTH:LOGIN:SUCCESS' action
// -----------------------------------------------------------------------------------------------------------------

export type LoginSuccessType = 'AUTH:LOGIN:SUCCESS';

type LoginSuccessActionArgs = {| jwt: JWT |};

export type LoginSuccessPayload = {| jwt: JWT |};

export type LoginSuccessAction = {
  type: LoginSuccessType,
  payload: LoginSuccessPayload
}

const loginSuccessPayloadFactory: (args: LoginSuccessActionArgs) => LoginSuccessPayload = ({jwt}) => ({jwt});

/**
 * @todo TESTS: Add all
 */
export const loginSuccess: (LoginSuccessActionArgs) => LoginSuccessAction = createAction(
  ('AUTH:LOGIN:SUCCESS': LoginSuccessType),
  loginSuccessPayloadFactory,
);


// -----------------------------------------------------------------------------------------------------------------
// 'AUTH:LOGIN:FAILURE' action
// -----------------------------------------------------------------------------------------------------------------

export type LoginFailureType = 'AUTH:LOGIN:FAILURE';

type LoginFailureActionArgs = {| username: string |};

export type LoginFailureMeta = {| username: string |};

export type LoginFailureAction = {
  type: LoginFailureType,
  error: Error,
  meta: LoginFailureMeta
}

const loginFailureMetaFactory: (Error, LoginFailureActionArgs) => LoginFailureMeta = (error, {username}) => ({username});

/**
 * @todo TESTS: Add all
 */
export const loginFailure: (Error, LoginFailureActionArgs) => LoginFailureAction = createAction(
  'AUTH:LOGIN:FAILURE',
  null,
  loginFailureMetaFactory,
);



// WEBPACK FOOTER //
// ./src/modules/auth/actions/login.js